import { isString } from 'lodash';

/**
 * 是否合法字符
 * @param {*} str 检测字符
 * @returns {Boolean}
 */
export function isAllowString(str) {
  if (!isString(str)) return false;

  const specificSymbolReg = [
    /[`~@^&#*|':;\"/?<>()\\\\]/g,
    /[\uD83C-\uD83E][\uDC00-\uDFFF]|[\u2600-\u27ff]/g,
  ];

  return specificSymbolReg.every(reg => !reg.test(str));
}

export function checkIsOneScreen() {
  const { hostname, search } = window.location
  if (hostname === 'class.onescreensolutions.com') {
    return true
  }
  if (sessionStorage.getItem('_from') === 'onescreensolutions') {
    return true
  }
  const urlSearchParams = new URLSearchParams(search)
  const { from } = Object.fromEntries(urlSearchParams.entries())
  if (from === 'onescreensolutions') {
    sessionStorage.setItem('_from', 'onescreensolutions')
    return true
  }
  return false
}